function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Send = function Send(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M13.7 22.37a.748.748 0 0 0 1.4.01l7.71-20.22c.11-.28.04-.59-.17-.8a.74.74 0 0 0-.8-.17L1.62 8.89c-.29.12-.48.4-.48.71s.2.59.49.7l8.82 3.25zm-2.846-10.284L4.03 9.58l16.78-6.39-6.39 16.78-2.506-6.824L15.25 9.81c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0z",
    clipRule: "evenodd"
  }));
};
export default Send;
Send.displayName = 'Send';